import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
    return (
        <div className="bg-background">
            {/* Header */}
            <div className="bg-primary py-16">
                <div className="section-container">
                    <Link to="/" className="inline-flex items-center gap-2 text-primary-foreground/80 hover:text-primary-foreground mb-6 transition-colors">
                        <ArrowLeft className="w-4 h-4" />
                        Back to Home
                    </Link>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-foreground">Privacy Policy</h1>
                    <p className="text-primary-foreground/80 mt-4">Last updated: November 07, 2024</p>
                </div>
            </div>

            {/* Content */}
            <div className="section-container py-16">
                <div className="max-w-4xl mx-auto prose prose-lg">
                    <p className="text-muted-foreground leading-relaxed">
                        This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and explains Your privacy rights and how the law protects You.
                    </p>
                    <p className="text-muted-foreground leading-relaxed">
                        By using our Service, You agree to the collection and use of information in accordance with this Privacy Policy.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Interpretation and Definitions</h2>
                    
                    <h3 className="text-xl font-semibold text-foreground mt-8 mb-3">Interpretation</h3>
                    <p className="text-muted-foreground leading-relaxed">
                        Words with capitalized initial letters have meanings defined under the following conditions and apply whether used in singular or plural.
                    </p>

                    <h3 className="text-xl font-semibold text-foreground mt-8 mb-3">Definitions</h3>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li><strong className="text-foreground">Company:</strong> Dhakad Enterprises, Devalkhedi Jhod Jadgdishpur Islam Nagar Road, Bhopal, MP 462038</li>
                        <li><strong className="text-foreground">Website:</strong> <a href="https://dhakadenterprises.in/" className="text-primary hover:underline">https://dhakadenterprises.in/</a></li>
                        <li><strong className="text-foreground">Service:</strong> The Website operated by the Company</li>
                        <li><strong className="text-foreground">Personal Data:</strong> Any information related to an identifiable individual</li>
                        <li><strong className="text-foreground">You:</strong> The individual using the Service</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Collecting and Using Your Personal Data</h2>
                    
                    <h3 className="text-xl font-semibold text-foreground mt-8 mb-3">Types of Data Collected</h3>
                    
                    <h4 className="text-lg font-semibold text-foreground mt-6 mb-2">Personal Data</h4>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li>Email address</li>
                        <li>First name and last name</li>
                        <li>Phone number</li>
                        <li>Address, City, State, Postal Code</li>
                    </ul>

                    <h4 className="text-lg font-semibold text-foreground mt-6 mb-2">Usage Data</h4>
                    <p className="text-muted-foreground leading-relaxed">
                        Usage Data is collected automatically and may include IP address, browser type, pages visited, time spent, and diagnostic data.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Cookies & Tracking Technologies</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        We use Cookies, web beacons, and similar technologies to improve user experience and analyze website performance.
                    </p>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2 mt-4">
                        <li><strong className="text-foreground">Essential Cookies:</strong> Required for core functionality</li>
                        <li><strong className="text-foreground">Acceptance Cookies:</strong> Store cookie consent</li>
                        <li><strong className="text-foreground">Functionality Cookies:</strong> Remember preferences</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Use of Your Personal Data</h2>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li>To operate and maintain our Service</li>
                        <li>To manage user accounts</li>
                        <li>To contact users via email or phone</li>
                        <li>To improve services and marketing efforts</li>
                        <li>To comply with legal obligations</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Data Retention & Security</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        We retain Personal Data only as long as necessary and apply reasonable security measures to protect Your information.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Children's Privacy</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        Our Service does not target users under 13 years of age, and we do not knowingly collect their data.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Changes to This Privacy Policy</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        We may update this policy from time to time. Any changes will be posted on this page with an updated revision date.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Contact Us</h2>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li><strong className="text-foreground">Email:</strong> <a href="mailto:Prashantdhakad12345@gmail.com" className="text-primary hover:underline">Prashantdhakad12345@gmail.com</a></li>
                        <li><strong className="text-foreground">Website:</strong> <a href="https://dhakadenterprises.in/" className="text-primary hover:underline">dhakadenterprises.in</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
